const UPDATE_INTL = 'intl/UPDATE'

const initialState = {
  locale: 'en',
  messages: {},
}

const intlReducer = (state = initialState, action) => {
  if (action.type === UPDATE_INTL) {
    return { ...state, ...action.payload }
  }
  return state
}

export default intlReducer
